import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../security/securityContext';
import Titulo from '../comum/Titulo';

export class MenuUsuario extends Component {
  render () {
    return (
      <div className="container-padrao">
        <Titulo texto="Usuários" urlRetorno="/"/>
        <div className="vx-menu-grid">
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <Link to="/painel-usuarios-sistema" className="vx-menu-card">
              <div className="vx-menu-card-icon">
                <i className="material-icons">admin_panel_settings</i>
              </div>
              <span className="vx-menu-card-label">Usuários Gerencial</span>
            </Link>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <Link to="/painel-usuarios-sites" className="vx-menu-card">
              <div className="vx-menu-card-icon">
                <i className="material-icons">devices</i>
              </div>
              <span className="vx-menu-card-label">Usuários Plataformas</span>
            </Link>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <Link to="/painel-usuarios-agencia" className="vx-menu-card">
              <div className="vx-menu-card-icon">
                <i className="material-icons">store</i>
              </div>
              <span className="vx-menu-card-label">Usuários Agência</span>
            </Link>
          </Autorizacao>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    authentication: state.authentication
  }
}

export default withRouter(connect(mapStateToProps, {})(MenuUsuario));
